import React from "react";
import s from "./DogFriendly.css";
import { flowRight as compose } from "lodash";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import { FormattedMessage, injectIntl } from "react-intl";
import { imageCdnUrl } from "../../../config";
import pawPrint from "../../../../public/SiteIcons/paw-print.svg";
import pawPrintRight from "../../../../public/SiteIcons/paw-print_right.svg";
import defaultIcon from "../../../../public/SiteIcons/defaultIcon.svg";
import messages from "../../../locale/messages";

class DogFriendly extends React.Component {
  render() {
    const { data } = this.props;

    return (
      <div className={s.dogFriendlySection}>
        {/* Decorative bowl image */}
        {/* <img
          src={`${imageCdnUrl}staticImages/bowl-dog.png`}
          alt="Dog food bowl"
          className={s.bowlImage}
        /> */}

        <div className={s.container}>
          <div className={s.wrapper}>
            {/* Left Image */}
            <div className={s.imageSection}>
              <img
                src={`${imageCdnUrl}staticImages/dog.png`}
                alt="Cute dog"
                className={s.image}
              />
            </div>

            {/* Right Content */}
            <div className={s.contentSection}>
              <img
                src={`${imageCdnUrl}staticImages/bowl-dog.png`}
                alt="Dog food bowl"
                className={s.bowlImage}
              />
              <h2 className={s.sectionTitle}>
                <FormattedMessage {...messages.dogFocussed} />
              </h2>
              <p className={s.sectionContent}>
                <FormattedMessage {...messages.dogFocussedDes} />
              </p>

              {/* Amenities Card */}
              {data?.length > 0 && (
                <div className={s.card}>
                  <img src={pawPrint} alt="" className={s.pawTop} />
                  <h3 className={s.cardTitle}>
                    <FormattedMessage {...messages.dogFriendly} />
                  </h3>
                  <div className={s.listHeight}>
                    <ul className={s.list}>
                      {data?.map((item, index) => (
                        <li className={s.item} key={index}>
                          <span className={s.icon}>
                            <img
                              src={
                                item.image
                                  ? imageCdnUrl +
                                    "/amenities/small_" +
                                    item.image
                                  : defaultIcon
                              }
                              alt={"Amenity"}
                              onError={(e) => {
                                e.currentTarget.src = defaultIcon;
                              }}
                            />
                          </span>
                          <span className={s.itemText}>{item.itemName}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <img src={pawPrintRight} alt="" className={s.pawBottom} />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default compose(injectIntl, withStyles(s))(DogFriendly);
